/* Deterministic text splitting.

   Framer splits these headlines per CHARACTER, which is why the reference
   markup is a long run of single-glyph spans. We reproduce that exactly, but
   the split has to be pure so the server and the client render the identical
   tree. Everything here is a function of the input string only. */

export type SplitPiece = {
    word: string
    chars: string[]
    trailingSpace: boolean
}

export const splitToWords = (text: string): SplitPiece[] => {
    const tokens = text.split(/(\s+)/).filter((token) => token.length > 0)
    const pieces: SplitPiece[] = []

    tokens.forEach((token) => {
        if (/^\s+$/.test(token)) {
            if (pieces.length > 0) {
                pieces[pieces.length - 1].trailingSpace = true
            }

            return
        }

        pieces.push({
            word: token,
            chars: Array.from(token),
            trailingSpace: false
        })
    })

    return pieces
}

/* Groups already-rendered char spans into visual lines by comparing their
   offsetTop. Used to build per-line overflow masks after mount, which is the
   only way to clip a reveal without cutting descenders. */
export const groupByLine = (nodes: HTMLElement[]): HTMLElement[][] => {
    const lines: HTMLElement[][] = []
    let current: HTMLElement[] = []
    let lastTop: number | null = null

    nodes.forEach((node) => {
        const top = node.offsetTop

        if (lastTop === null || Math.abs(top - lastTop) < 4) {
            current.push(node)
        } else {
            lines.push(current)
            current = [node]
        }

        lastTop = top
    })

    if (current.length > 0) {
        lines.push(current)
    }

    return lines
}
